export function addOverrides(flags: {
    [feature: string]: boolean;
}, overrides: {
    [feature: string]: boolean;
}): void {
    for (const key of Object.keys(overrides)) {
        flags[key.toLowerCase()] = overrides[key];
    }
}
